import * as boardsStore from '../../extensions/bundled/task-manager/boardsStore';

// Drag-and-drop is switched off while any filter is active by handing DndContext
// an empty sensor list — no sensor, no gesture. This is not cosmetic: dropping a
// card inside a FILTERED column writes positions computed against the cards the
// user can see, silently renumbering the ones hidden by the filter. The filter
// bar states the reason on screen, and the columns are greyed to match.
export const NO_SENSORS = [];

export const sortByPosition = (tasks) => tasks.sort(boardsStore.compareTasksByPosition);
